// extracted by mini-css-extract-plugin
export default {"skills-cardcontainer":"Skills_skills-cardcontainer__9qbtW"};